import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Cristina M.",
      content:
        "Ce bucurie mai mare sa ai decat aceea in care vezi o Sfanta Evanghelie daruita pentru un suflet, asezata cu cinste, pe Sfanta Masa! Sau un Apostol, deschis la fiecare slujba, in nadejdea pomenirii celui drag, de catre Bunul Dumnezeu",
      rating: 5,
    },
    {
      name: "Constantinescu Adriana",
      content:
        "Despre cărțile noastre cineva ne-a trimis câteva cuvinte: Le iubesc, mă bucur ținându-le in mână, stiindu-mi-le în casă si ele îmi dau, la rându-le, mângâierea lor!",
      rating: 5,
    },
    {
      name: "Parintele Vasile Marius A.",
      content:
        "E deosebit ceea ce faceți!",
      rating: 5,
    },
    {
      name: "Maica Sebastiana",
      content:
        "Sunt minunate! Maica Domnului să vă ocrotească mereu!",
      rating: 5,
    },
    {
      name: "Arvai Cătălin",
      content:
        "Am primit Arhieraticonul marți. Totul este la superlativ. Multumesc. Toate cele bune.",
      rating: 5,
    },
    {
      name: "Pr. Sabin Voda",
      content:
        "Am primit acum Biblia. Nici nu vă puteți da seama ce mare bucurie am avut când am vazut-o. Cartea arată impecabil. Ți-e mai mare dragul să o ții în mână. Felicitări! Bibilia chiar merită să fie copertată în piele.",
      rating: 5,
    },
    {
      name: "Bogdan Murar",
      content:
        "Va mulțumesc pentru carti. Superbe. Carti este puțin spus… felicitări pentru ceea ce realizați! Numai bine va doresc și Doamne ajuta!",
      rating: 5,
    },
    {
      name: "Mihai T.",
      content:
        "Psaltirea dvs.arată deschiderea către sufletul și mulțumirea clientului, este într-adevăr o expresie a dragostei și nu un interes pur comercial. Sunt foarte mulțumit de produsele lucrate în atelierul IDACO. Mulțumesc pentru dar din har!",
      rating: 5,
    },
  ];

  return (
    <section id="review" className="py-20 bg-gradient-to-b from-cream/30 to-background relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12 sm:mb-16 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-gold/10 rounded-full mb-4 sm:mb-6">
            <Star className="w-3 h-3 sm:w-4 sm:h-4 text-gold fill-gold" />
            <span className="text-gold font-semibold text-xs sm:text-sm">Recenzii autentice</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-3 sm:mb-4 px-2">
            Ce spun clienții noștri
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto font-lora px-4">
            Mărturia celor care au descoperit frumusețea cărților noastre
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 md:gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.name}
              className="group bg-card/80 backdrop-blur-sm border-2 border-border/50 hover:border-gold/30 transition-all duration-500 hover-scale hover-glow overflow-hidden animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardContent className="p-5 sm:p-6 md:p-8 relative">
                {/* Quote icon */}
                <Quote className="absolute top-3 right-3 sm:top-4 sm:right-4 w-10 h-10 sm:w-12 sm:h-12 text-gold/10 group-hover:text-gold/20 transition-colors" />

                {/* Rating */}
                <div className="flex gap-1 mb-4 sm:mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-gold fill-gold"
                    />
                  ))}
                </div>

                {/* Content */}
                <p className="text-muted-foreground mb-4 sm:mb-6 font-lora leading-relaxed italic text-sm sm:text-base">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="pt-4 sm:pt-6 border-t border-border/50">
                  <p className="font-bold text-sm sm:text-base text-foreground group-hover:text-primary transition-colors font-playfair">
                    {testimonial.name}
                  </p>
                </div>

                {/* Decorative element */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-gold via-accent to-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-12 sm:mt-16 flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 items-center animate-fade-in px-4" style={{ animationDelay: '0.8s' }}>
          <div className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-card/50 rounded-full border border-border/50">
            <Star className="w-4 h-4 sm:w-5 sm:h-5 text-gold fill-gold" />
            <span className="font-semibold text-foreground text-sm sm:text-base">5.0/5</span>
            <span className="text-muted-foreground text-xs sm:text-sm font-lora">Din 8+ recenzii</span>
          </div>
          <div className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-card/50 rounded-full border border-border/50">
            <span className="font-semibold text-foreground text-sm sm:text-base">100%</span>
            <span className="text-muted-foreground text-xs sm:text-sm font-lora">Clienți mulțumiți</span>
          </div>
          <div className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-card/50 rounded-full border border-border/50">
            <span className="font-semibold text-foreground text-sm sm:text-base">20+</span>
            <span className="text-muted-foreground text-xs sm:text-sm font-lora">Ani experiență</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
